import React, { useContext, useState } from "react";
import { AppContext } from "./index.js";
import Boton from "./Boton";
import add from "./img/add.png";

export default function CRUDcategorias() {
  let { firebase } = useContext(AppContext);

  const [categorias, setCategorias] = useState(firebase.dataCategorias);

  function actualizarCategorias() {
    firebase.actualizarCategorias(categorias);
  }

  return (
    <div style={Scategorias}>
      {categorias.map((c, ind) => (
        <input
          key={ind}
          value={c.id}
          style={SInput}
          onChange={(e) => {
            e.persist();
            let aux = [...categorias];
            aux[ind].id = e.currentTarget.value;
            setCategorias([...aux]);
          }}
        />
      ))}

      <Boton size={30} accion={actualizarCategorias} />
      <img
        src={add}
        alt="+"
        title="Agregar Categoría"
        height="30px"
        width="30px"
        onClick={() => {
          setCategorias((c) => [...c, { id: "" }]);
        }}
      />
    </div>
  );
}

const Scategorias = {
  margin: "30px 0px 0px 30px",
  width: "30vw",
  display: "flex",
  flexDirection: "column",
};

const SInput = {
  border: "1px ridge",
  padding: "6px 0px 6px 2px",
  fontSize: "2vh",
  margin: "5px",
  height: "30px",
  borderRadius: "5px",
};
